var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPendingToReviewForApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82031 13.125C6.16549 13.125 6.44531 12.8452 6.44531 12.5C6.44531 12.1548 6.16549 11.875 5.82031 11.875C5.47513 11.875 5.19531 12.1548 5.19531 12.5C5.19531 12.8452 5.47513 13.125 5.82031 13.125Z",
    fill: "#364153"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5703 8.125C14.9155 8.125 15.1953 7.84518 15.1953 7.5C15.1953 7.15482 14.9155 6.875 14.5703 6.875C14.2251 6.875 13.9453 7.15482 13.9453 7.5C13.9453 7.84518 14.2251 8.125 14.5703 8.125Z",
    fill: "#364153"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82031 3.75C6.16549 3.75 6.44531 3.47018 6.44531 3.125C6.44531 2.77982 6.16549 2.5 5.82031 2.5C5.47513 2.5 5.19531 2.77982 5.19531 3.125C5.19531 3.47018 5.47513 3.75 5.82031 3.75Z",
    fill: "#364153"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82031 10C5.82031 7.59167 7.78698 5.625 10.1953 5.625C11.262 5.625 12.237 6.00833 12.9953 6.64167L13.7953 5.68333C12.8203 4.86667 11.562 4.375 10.1953 4.375C7.08698 4.375 4.57031 6.89167 4.57031 10C4.57031 10.325 4.60365 10.6417 4.65365 10.9583L5.88698 10.7417C5.84531 10.5 5.82031 10.25 5.82031 10Z",
    fill: "#364153"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.69531 10C2.69531 7.93333 3.53698 6.05833 4.89531 4.7L4.01198 3.81667C2.42865 5.4 1.44531 7.59167 1.44531 10C1.44531 14.8333 5.36198 18.75 10.1953 18.75V17.5C6.06198 17.5 2.69531 14.1333 2.69531 10Z",
    fill: "#364153"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1953 2.5C14.3286 2.5 17.6953 5.86667 17.6953 10H18.9453C18.9453 5.16667 15.0286 1.25 10.1953 1.25C9.14531 1.25 8.14531 1.44167 7.21198 1.78333L7.63698 2.95833C8.43698 2.66667 9.29531 2.5 10.1953 2.5Z",
    fill: "#364153"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3953 17.575L12.237 15.4167L11.062 16.5917L14.3953 19.925L20.2287 14.0917L19.0537 12.9167L14.3953 17.575Z",
    fill: "#364153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPendingToReviewForApproval);
export default __webpack_public_path__ + "static/media/ic-pending-to-review-for-approval.089fb146f80cc7a80d8da93fc7b23f29.svg";
export { ForwardRef as ReactComponent };